import styled, { css } from 'styled-components';
import { InputStyle } from '../input/input';
import { RichTextEditor as BaseRichTextEditor } from '../rich-text-editor';
import { RichTextEditorValueType } from '../rich-text-editor/types';

const Editor = styled(BaseRichTextEditor)<{
  readonly?: boolean;
}>`
  --rte-min-height: 7rem;
  border-radius: var(--border-radius-small);
  .rte-editor {
    ${InputStyle};
    padding: var(--spacing-04) var(--spacing-05);
    overflow-y: unset;
    max-height: unset;
    ${({ readonly }) =>
      !readonly
        ? css`
            resize: vertical;
            min-height: var(--rte-min-height);
            overflow: auto;
          `
        : css`
            height: auto;
          `};
  }
` as typeof BaseRichTextEditor;

interface Props<T extends RichTextEditorValueType> {
  value?: T;
  placeholder?: string;
  onChange?: (value: T) => void;
  readonly?: boolean;
  className?: string;
}
const RichTextEditorComponent = <T extends RichTextEditorValueType>({
  value,
  placeholder,
  onChange,
  className,
  readonly = false,
}: Props<T>) => {
  return (
    <Editor<T>
      className={className}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      readonly={readonly}
    />
  );
};
const StyledEditor = styled(RichTextEditorComponent)``;

export const RichTextEditorInput: typeof RichTextEditorComponent = StyledEditor;
